<app-overlay-message></app-overlay-message>
<div *ngIf="responseNull" class="response-null">
  &nbsp;{{ responseNull }}
  <div class="response-null-conatiner">

  <button class="response-null-btn" (click)="openModal()">
    Config Details
  </button>
</div>
</div>
<div *ngIf="modalOpen" class="modal-overlay" (click)="closeModal()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <h2>Upload Config File</h2>
    <input
      type="file"
      accept=".xlsx"
      (change)="onFileSelected($event)"
      class="file-input"
    />

    <button
      (click)="uploadFile()"
      [disabled]="!selectedFile"
      class="upload-btn"
    >
      Upload File
    </button>

    <button (click)="closeModal()" class="close-btn">Close</button>
  </div>
</div>

<div class="config-build-layout" *ngIf="modulesCount > 0">
  <div class="config-build-module-header">
    Modules <span class="total-module">{{ modulesCount }}</span>
    <div class="config-buttons">

    <button class="config-download" (click)="downloadExcel()">
      Download Config
    </button>
    <button class="config-upload" (click)="openModal()">Upload Config</button>
  </div>
  </div>

  <div class="config-build-card-container">
    <div class="modules-card">
      <div *ngFor="let configData of configBuildData; let i = index">
        <div
          class="modules-data-row"
          (click)="handleModuleSelection(configData, i + 1)"
          [ngStyle]="{
            background:
              selectedModuleName === configData.module_name ? '#ECF8FF' : ''
          }"
        >
          <span
            class="module-sequence"
            [ngStyle]="{
              background:
                selectedModuleName === configData.module_name ? '#2E3238' : '',
              color:
                selectedModuleName === configData.module_name ? '#FFFFFF' : ''
            }"
          >
            {{ i + 1 }}
          </span>
          <span class="module-name">{{ configData.module_name }}</span>
          <div class="module-completion-tick">
            <img
              src="assets/Config-Build/Complete.svg"
              alt="ModuleCompleteTick"
              *ngIf="configData.is_module_complete === 1"
            />
            <img
              src="assets/Config-Build/Incomplete.svg"
              alt="ModuleIncomplete"
              *ngIf="configData.is_module_complete === 0"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="config-card">
      <div class="module-number-button-container">
        <span class="selected-module-number">
          Module {{ selectedModuleNumber }}/{{ modulesCount }}
        </span>
      </div>
      <div class="selected-module-title">
        {{ selectedModuleName }}
      </div>
      <div class="selected-module-config-container">
        <table class="table">
          <thead>
            <tr>
              <th>
                <div class="config-card-header">
                  <div class="config-task-search">
                    <img
                      src="assets/Config-Build/Search.svg"
                      alt=""
                      class="search-icon"
                    (click)="onClickSearch()"
                    />
                    <input
                      type="text"
                      id="searchInput"
                      [(ngModel)]="searchKey"
                      (input)="handleTaskSearch()"
                      (focus)="handleFocus()"
                      (blur)="handleBlur()"
                      placeholder=" {{ globalSearchFocused ? 'Search' : '' }}"
                      class="search-input"
                    />
                  </div>
                  <div class="config-task-filter">
                    <div
                      class="config-build-filter-panel"
                      *ngIf="filterPanelVisible"
                    >
                      <div class="config-build-filter-panel-header">
                        <!-- <span class="filter-header-title">Tasks</span> -->
                        <button
                          (click)="handleResetAll()"
                          class="reset-all-btn"
                        >
                          Reset All
                        </button>
                      </div>
                      <div class="config-build-filter-panel-content">
                        <div
                          *ngFor="let option of multiSelectFilterOptions"
                          class="filter-option"
                        >
                          <input
                            type="checkbox"
                            [checked]="checkedStatus(option)"
                            (click)="handleOptionCheckboxSelection(option)"
                            [id]="option.label"
                            [name]="option.label"
                          />
                          <label
                            for="{{ option.label }}"
                            class="filter-option-label"
                          >
                            {{ option.label }}
                          </label>
                        </div>
                      </div>
                      <div class="config-build-filter-panel-footer">
                        <button
                          (click)="filterPanelVisible = false"
                          class="config-build-filter-apply-button"
                        >
                          Close
                        </button>
                        <button
                          (click)="handleFilterApply()"
                          class="config-build-filter-apply-button apply-button"
                        >
                          Apply
                        </button>
                      </div>
                    </div>
                    <button
                      (click)="toggleFilterPanel()"
                      class="config-build-filter-button"
                    >
                      <img src="assets/Config-Build/Filter.svg" alt="filter" />
                    </button>
                  </div>
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            <div class="no-task">
              <div  *ngIf="taskData">{{taskData}}</div>
            </div>
           
            <tr *ngFor="let task of selectedModuleConfigTasks; let i = index">
              <td>
                <div class="config-task-accordian-header">
                  <div class="task-container">
                    <div class="task-number">{{ i + 1 }}.</div>
                 
                    <div class="task-text" data-fulltext="{{ task.task_name }}">
                      {{ task.task_name }}
                    </div>
                  </div>
                  <mat-button-toggle-group
                    name="taskStatus"
                    [(ngModel)]="task.is_task_complete"
                    aria-label="Task Status"
                  >
                    <mat-button-toggle
                      value="0"
                      [class.inComplete]="task.is_task_complete === 0"
                      (click)="handleTaskComplete(task, 0)"
                      class="toggle-button"
                    >
                      Incomplete
                    </mat-button-toggle>
                    <mat-button-toggle
                      value="1"
                      [class.complete]="task.is_task_complete === 1"
                      (click)="handleTaskComplete(task, 1)"
                      class="toggle-button"
                    >
                      Complete
                    </mat-button-toggle>
                  </mat-button-toggle-group>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
